const routes = [
  {
    path: "/companies",
    component: () => import("@/views/Companies.vue"),
    redirect: { name: "companies" },
    name: "companies_branch",
    children: [
      {
        path: "/",
        component: () => import("@/views/Company/List.vue"),
        name: "companies",
      },
      {
        path: "new",
        component: () => import("@/views/Company/Edit.vue"),
        name: "company_new",
      },
      {
        path: ":id/edit",
        component: () => import("@/views/Company/Edit.vue"),
        name: "company_edit",
      },
      {
        path: ":id/details",
        component: () => import("@/views/Company/Show.vue"),
        name: "company_details",
      },
      {
        path: ":id/analysis/:analysisId",
        component: () => import("@/views/Company/Analysis.vue"),
        name: "company_analysis",
      },
      {
        path: ":id/analysis/:analysisId/medium_detail",
        component: () => import("@/views/Company/AnalysisMediumDetail.vue"),
        name: "company_analysis_medium_detail",
      },
      {
        path: ":id/analysis/:analysisId/group/create",
        component: () => import("@/views/Company/Group/Create.vue"),
        name: "create_group",
      },
      {
        path: ":id/analysis/:analysisId/group/:groupId/edit",
        component: () => import("@/views/Company/Group/Edit.vue"),
        name: "edit_group",
      },
      {
        path: ":id/map",
        component: () => import("@/views/Company/Map.vue"),
        name: "company_map",
        redirect: { name: "company-poi" },

        children: [
          {
            path: "poi",
            component: () => import("@/views/Company/Poi.vue"),
            name: "company-poi",
          },
          {
            path: "poi/:poi_id",
            component: () => import("@/views/Company/Poi/Show.vue"),
            name: "company-poi-show",
          },
          {
            path: "poi_search",
            component: () => import("@/views/Company/PoiSearch.vue"),
            name: "company-poi-search",
          },
        ],
      },
    ],
  },
];

export default routes;
